module.exports = __webpack_public_path__ + "img/new_img3.0e7e1298.png";